import { render } from "./questionAnswer.vue?vue&type=template&id=65af4360&scoped=true"
import script from "./questionAnswer.vue?vue&type=script&lang=js"
export * from "./questionAnswer.vue?vue&type=script&lang=js"

import "./questionAnswer.vue?vue&type=style&index=0&id=65af4360&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65af4360"]])

export default __exports__